import React, { Component, useState, useEffect } from "react";
import axios from "axios";
import styled from "styled-components";

import AS from "../Login/Service/Authentication";
import CS from "../../commons/services/Common";
import VS from "../../commons/services/Validation";

import PageTitle from "../../commons/components/PageTitle";
import AddressSearch from "../../commons/components/AddressSearch";
import Modal from "../../commons/components/Modal";
import { ROUTES } from "../../commons/constants/routes/routes";
import InputErrorMsgWrapper from "../../commons/components/input/InputErrorWrap";
import { withTranslation } from "react-i18next";
import { InputTitleWidth } from "./tanslationUiConst";
import DeleteButton from "../../commons/components/button/DeleteButton";
import PaginationButtons from "../../commons/components/pagination/PaginationButtons";

class ProjectEdit extends Component {
  constructor(props) {
    super(props);
    this.state = {
      projectId: null,
      addrxy: { addr: "", x: "", y: "" },
      isSaved: false,
      validationErrors: {},
      siteManagers: [],
      // 기존 데이터
      projectName: "",
      projectAddr: "",
      projectAddrDetail: "",
      projectCustomerName: "",
      projectCustomerPhone: "",
      projectCustomerEmail: "",
      projectSiteManagerId: "",
      projectSiteNo: "",
      projectStatus: "",
      projectRequestMsg: "",
      requestFiles: [null, null, null, null, null],
      linkedMembers: [],
      showMemberPopup: false,
      allMembers: [],
      selectedMemberIds: [],
      popupKeyword: "",
      popupPage: 1,
    };

    this.handleSubmit = this.handleSubmit.bind(this);
    this.setAddrXY = this.setAddrXY.bind(this);
    this.checkAddressValidation = this.checkAddressValidation.bind(this);
    this.handleFacilityUpdate = this.handleFacilityUpdate.bind(this);
    this.handleDeleteProject = this.handleDeleteProject.bind(this);
    this.handleGenerateSiteNo = this.handleGenerateSiteNo.bind(this);
    this.openMemberPopup = this.openMemberPopup.bind(this);
    this.closeMemberPopup = this.closeMemberPopup.bind(this);
    this.handleAddMembers = this.handleAddMembers.bind(this);
  }

  async componentDidMount() {
    const projectId = window.location.pathname.split("/").pop();
    this.setState({ projectId });
    await Promise.all([
      this.getProjectItems(projectId),
      this.getSiteManagers(),
      this.getLinkedMembers(projectId),
    ]);
  }

  async getSiteManagers() {
    try {
      const res = await axios.get("/api/account/account", { params: { userType: "USR_S" } });
      this.setState({ siteManagers: res.data.data || [] });
    } catch (e) {
      console.log(e);
    }
  }

  async getLinkedMembers(projectId) {
    try {
      const res = await axios.get(`/cst/api/user-project/${projectId}`);
      this.setState({ linkedMembers: res.data || [] });
    } catch (e) {
      console.log(e);
    }
  }

  async openMemberPopup() {
    try {
      const res = await axios.get("/api/account/account", { params: { userType: "USR_P" } });
      this.setState({ allMembers: res.data.data || [], selectedMemberIds: [], popupKeyword: "", popupPage: 1, showMemberPopup: true });
    } catch (e) {
      console.log(e);
    }
  }

  closeMemberPopup() {
    this.setState({ showMemberPopup: false, selectedMemberIds: [], popupKeyword: "", popupPage: 1 });
  }

  toggleMemberSelection(id) {
    const { selectedMemberIds } = this.state;
    if (selectedMemberIds.includes(id)) {
      this.setState({ selectedMemberIds: selectedMemberIds.filter((v) => v !== id) });
    } else {
      this.setState({ selectedMemberIds: [...selectedMemberIds, id] });
    }
  }

  async handleAddMembers() {
    const { projectId, selectedMemberIds } = this.state;
    try {
      await Promise.all(
        selectedMemberIds.map((userId) =>
          axios.post("/cst/api/user-project", { projectId: Number(projectId), userId })
        )
      );
      await this.getLinkedMembers(projectId);
      this.closeMemberPopup();
    } catch (e) {
      console.log(e);
    }
  }

  async handleRemoveMember(userId) {
    const { projectId } = this.state;
    try {
      await axios.delete(`/cst/api/user-project/${projectId}/${userId}`);
      await this.getLinkedMembers(projectId);
    } catch (e) {
      console.log(e);
    }
  }

  async getProjectItems(projectId) {
    try {
      const res = await axios.get(`/cst/api/project/id/${projectId}`);
      const d = res.data;
      this.setAddrXY(d.address, d.lngX, d.latY);
      this.setState({
        projectName: d.name || "",
        projectAddr: d.address || "",
        projectAddrDetail: d.addressDetail || "",
        projectCustomerName: d.customerName || "",
        projectCustomerPhone: d.customerPhone || "",
        projectCustomerEmail: d.customerEmail || "",
        projectSiteManagerId: d.siteManagerId || "",
        projectSiteNo: d.siteNo != null ? String(d.siteNo) : "",
        projectStatus: d.status ? String(d.status) : "",
        projectRequestMsg: d.requestMsg || "",
        requestFiles: [
          d.requestFile1Id ? { id: d.requestFile1Id, name: null, isImage: true } : null,
          d.requestFile2Id ? { id: d.requestFile2Id, name: null, isImage: true } : null,
          d.requestFile3Id ? { id: d.requestFile3Id, name: null, isImage: true } : null,
          d.requestFile4Id ? { id: d.requestFile4Id, name: null, isImage: true } : null,
          d.requestFile5Id ? { id: d.requestFile5Id, name: null, isImage: true } : null,
        ],
      });
    } catch (e) {
      console.log(e);
    }
  }

  validateForm(data) {
    const validationErrors = {};
    const { t } = this.props;

    if (!data.get("name")) {
      validationErrors.name = t('key514');
    } else if (!VS.isLengthValid({ str: data.get("name"), max: 36 })) {
      validationErrors.name = t('key517');
    }
    if (!data.get("address")) {
      validationErrors.address = t('key515');
    }
    if (!data.get("addressDetail")) {
      validationErrors.addressDetail = "상세주소를 입력해주세요.";
    }
    if (!data.get("siteNo")) {
      validationErrors.siteNo = "Site 번호를 입력해주세요.";
    }
    if (!data.get("customerName")) {
      validationErrors.customerName = "고객명을 입력해주세요.";
    }
    if (!data.get("customerPhone")) {
      validationErrors.customerPhone = "고객 전화번호를 입력해주세요.";
    }
    if (data.get("customerEmail") && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(data.get("customerEmail"))) {
      validationErrors.customerEmail = "올바른 이메일 형식이 아닙니다.";
    }

    if (Object.keys(validationErrors).length > 0) {
      this.setState({ validationErrors });
      return false;
    }
    return true;
  }

  async handleSubmit(e) {
    e.preventDefault();
    const isSaved = await this.saveProject();
    if (isSaved) {
      this.setState({ isSaved: true });
    }
  }

  async handleFacilityUpdate(e) {
    e.preventDefault();
    const data = new FormData(document.querySelector("form"));
    const name = data.get("name");

    if (this.state.isSaved) {
      this.props.history.push({
        pathname: ROUTES.PLANT_LIST(this.state.projectId).MAIN,
        state: { projectTitle: name },
      });
      return;
    }

    const isSaved = await this.saveProject();
    if (isSaved) {
      this.setState({ isSaved: true });
      this.props.history.push({
        pathname: ROUTES.PLANT_LIST(this.state.projectId).MAIN,
        state: { projectTitle: name },
      });
    } else {
      this.props.history.push({
        pathname: ROUTES.PLANT_LIST(this.state.projectId).MAIN,
        state: { projectTitle: name },
      });
    }
  }

  async saveProject() {
    const data = new FormData(document.querySelector("form"));
    if (!this.validateForm(data)) return false;

    const item = {
      id: this.state.projectId,
      constructorId: AS.getLoggedInId(),
      name: data.get("name"),
      address: data.get("address"),
      addressDetail: data.get("addressDetail"),
      siteNo: data.get("siteNo") || null,
      latY: this.state.addrxy.y,
      lngX: this.state.addrxy.x,
      customerName: data.get("customerName"),
      customerPhone: data.get("customerPhone"),
      customerEmail: data.get("customerEmail") || null,
      ...(data.get("siteManagerId") ? { siteManagerId: data.get("siteManagerId") } : {}),
      ...(this.state.projectStatus ? { status: this.state.projectStatus } : {}),
      ...(this.state.projectStatus === "4" ? (() => {
        const [f1, f2, f3, f4, f5] = this.state.requestFiles;
        return {
          requestMsg: this.state.projectRequestMsg,
          ...(f1 !== null && { request_file1_id: f1.id }),
          ...(f2 !== null && { request_file2_id: f2.id }),
          ...(f3 !== null && { request_file3_id: f3.id }),
          ...(f4 !== null && { request_file4_id: f4.id }),
          ...(f5 !== null && { request_file5_id: f5.id }),
        };
      })() : {}),
    };

    try {
      const result = await CS.update("/cst/api/project", item);
      if (result.isSuccess) {
        return true;
      }
      return false;
    } catch (e) {
      return false;
    }
  }

  handleRequestFileChange = async (index, e) => {
    const file = e.target.files[0];
    const input = e.target;
    if (!file) return;
    try {
      const formData = new FormData();
      formData.append("file", file);
      const res = await axios.post("/api/file", formData, {
        headers: { "content-type": "multipart/form-data" },
      });
      const dataArr = Array.isArray(res.data?.data) ? res.data.data
                   : Array.isArray(res.data) ? res.data
                   : [];
      const uploaded = dataArr[0];
      if (!uploaded) {
        console.log("파일 업로드 응답 파싱 실패", res.data);
        return;
      }
      const newFiles = [...this.state.requestFiles];
      newFiles[index] = {
        id: uploaded.id,
        name: uploaded.fileName,
        isImage: uploaded.mimeType?.startsWith("image/"),
      };
      this.setState({ requestFiles: newFiles });
    } catch (e) {
      console.log("파일 업로드 오류", e);
    }
    input.value = "";
  };

  handleRequestFileRemove = (index) => {
    const newFiles = [...this.state.requestFiles];
    newFiles[index] = null;
    this.setState({ requestFiles: newFiles });
  };

  async handleDeleteProject(e) {
    e.preventDefault();
    const { t } = this.props;
    try {
      const result = await CS.delete(`/cst/api/project/${this.state.projectId}`);
      if (result.isSuccess) {
        alert(t('key563'));
        document.location.href = ROUTES.PROJECT.MAIN;
      }
    } catch (error) {
      console.error("프로젝트 삭제 중 오류가 발생했습니다:", error);
    }
  }

  setAddrXY(address, longitude, latitude) {
    const { validationErrors } = this.state;
    delete validationErrors.address;
    this.setState({
      projectAddr: address,
      addrxy: { addr: address, x: longitude, y: latitude },
      validationErrors,
    });
  }

  checkAddressValidation(e) {
    const { t } = this.props;
    alert(t('key519'));
    e.target.blur();
  }

  async handleGenerateSiteNo() {
    const addr = this.state.addrxy.addr;
    if (!addr) {
      alert("먼저 주소를 검색해 주세요.");
      return;
    }
    try {
      // 1. 카카오 API로 법정동 코드(b_code) 조회
      let bcode = "";
      try {
        sessionStorage.setItem("kakao", "true");
        const kakaoRes = await axios.get(
          `https://dapi.kakao.com/v2/local/search/address.json?query=${encodeURIComponent(addr)}`
        );
        bcode = kakaoRes.data.documents[0]?.address?.b_code || "";
      } finally {
        sessionStorage.removeItem("kakao");
      }

      if (!bcode) {
        alert("법정코드를 가져올 수 없습니다.");
        return;
      }

      // 2. 동일 법정동코드(10자리)의 기존 최대 siteNo 조회
      const maxRes = await axios.get("/api/project/search-by-site-no/max", {
        params: { siteNo: bcode },
      });
      const maxSiteNo = maxRes.data?.result;

      // 3. 최대값이 있으면 +1, 없으면 법정동코드 + "00001"
      const newSiteNo = maxSiteNo
        ? String(Number(maxSiteNo) + 1)
        : bcode + "00001";

      const { validationErrors } = this.state;
      delete validationErrors.siteNo;
      this.setState({ projectSiteNo: newSiteNo, validationErrors });

    } catch (e) {
      alert("Site 번호 생성 중 오류가 발생했습니다.");
    }
  }

  render() {
    const {
      validationErrors,
      siteManagers,
      projectName, projectAddr, projectAddrDetail,
      projectCustomerName, projectCustomerPhone, projectCustomerEmail,
      projectSiteManagerId, projectSiteNo,
      projectStatus, projectRequestMsg, requestFiles,
      linkedMembers, showMemberPopup, allMembers, selectedMemberIds, popupKeyword, popupPage,
    } = this.state;
    const linkedUserIds = linkedMembers.map((m) => m.userId);
    const filteredMembers = allMembers.filter((m) => {
      if (!popupKeyword) return true;
      const normalizedKeyword = popupKeyword.replace(/-/g, "");
      const normalizedPhone = (m.phone || "").replace(/-/g, "");
      return (
        (m.userName && m.userName.includes(popupKeyword)) ||
        normalizedPhone.includes(normalizedKeyword)
      );
    });
    const popupPageSize = 10;
    const popupTotalPageCount = Math.ceil(filteredMembers.length / popupPageSize) || 1;
    const pagedMembers = filteredMembers.slice((popupPage - 1) * popupPageSize, popupPage * popupPageSize);
    const { t, i18n } = this.props;

    return (
      <>
        <PageTitle title={t('key51')} location={t('key52')} />
        <FormWapper onSubmit={this.handleSubmit}>
          <FormContainer>
            <FormBox>
              <FormHead width={InputTitleWidth(i18n)} required={true}>{t('key53')}</FormHead>
              <FormBody>
                <InputErrorMsgWrapper isError={validationErrors.name} message={validationErrors.name}>
                  <input
                    type="text"
                    name="name"
                    id="name"
                    className="comm-inp"
                    placeholder={t('key54')}
                    defaultValue={projectName}
                    key={projectName}
                    onChange={(e) => {
                      const { validationErrors } = this.state;
                      if (!VS.isLengthValid({ str: e.target.value, max: 36 })) {
                        validationErrors.name = "프로젝트명은 36자 이하여야 합니다.";
                      } else {
                        delete validationErrors.name;
                      }
                      this.setState({ validationErrors });
                      VS.characterCheck(e);
                    }}
                  />
                </InputErrorMsgWrapper>
              </FormBody>
            </FormBox>

            <FormBox>
              <FormHead width={InputTitleWidth(i18n)} required={true}>{t('key55')}</FormHead>
              <FormBody>
                <InputErrorMsgWrapper isError={validationErrors.address} message={validationErrors.address}>
                  <input
                    type="text"
                    name="address"
                    id="address"
                    className="comm-inp"
                    placeholder={t('key56')}
                    defaultValue={projectAddr}
                    key={projectAddr}
                    onFocus={this.checkAddressValidation}
                  />
                </InputErrorMsgWrapper>
                <AddressSearch setAddrXY={this.setAddrXY} />
              </FormBody>
            </FormBox>

            <FormBox>
              <FormHead width={InputTitleWidth(i18n)} required={true}>상세주소</FormHead>
              <FormBody>
                <InputErrorMsgWrapper isError={validationErrors.addressDetail} message={validationErrors.addressDetail}>
                  <input
                    type="text"
                    name="addressDetail"
                    className="comm-inp"
                    placeholder="상세주소를 입력하세요"
                    defaultValue={projectAddrDetail}
                    key={projectAddrDetail}
                    onChange={() => {
                      const { validationErrors } = this.state;
                      delete validationErrors.addressDetail;
                      this.setState({ validationErrors });
                    }}
                  />
                </InputErrorMsgWrapper>
              </FormBody>
            </FormBox>

            <FormBox>
              <FormHead width={InputTitleWidth(i18n)} required={true}>Site 번호</FormHead>
              <FormBody>
                <InputErrorMsgWrapper isError={validationErrors.siteNo} message={validationErrors.siteNo}>
                  <input
                    type="text"
                    name="siteNo"
                    className="comm-inp"
                    placeholder="Site 번호를 입력하세요"
                    value={projectSiteNo}
                    onChange={(e) => {
                      VS.onInput("number", e);
                      const { validationErrors } = this.state;
                      delete validationErrors.siteNo;
                      this.setState({ projectSiteNo: e.target.value, validationErrors });
                    }}
                  />
                </InputErrorMsgWrapper>
                <button
                  type="button"
                  className="btn primary w150 ml-10"
                  onClick={this.handleGenerateSiteNo}
                >
                  Site 번호 생성
                </button>
              </FormBody>
            </FormBox>

            <FormBox>
              <FormHead width={InputTitleWidth(i18n)} required={true}>고객명</FormHead>
              <FormBody>
                <InputErrorMsgWrapper isError={validationErrors.customerName} message={validationErrors.customerName}>
                  <input
                    type="text"
                    name="customerName"
                    className="comm-inp"
                    placeholder="고객명을 입력하세요"
                    defaultValue={projectCustomerName}
                    key={projectCustomerName}
                    onChange={() => {
                      const { validationErrors } = this.state;
                      delete validationErrors.customerName;
                      this.setState({ validationErrors });
                    }}
                  />
                </InputErrorMsgWrapper>
              </FormBody>
            </FormBox>

            <FormBox>
              <FormHead width={InputTitleWidth(i18n)} required={true}>고객 전화번호</FormHead>
              <FormBody>
                <InputErrorMsgWrapper isError={validationErrors.customerPhone} message={validationErrors.customerPhone}>
                  <input
                    type="text"
                    name="customerPhone"
                    className="comm-inp"
                    placeholder="고객 전화번호를 입력하세요"
                    defaultValue={projectCustomerPhone}
                    key={projectCustomerPhone}
                    onChange={(e) => {
                      const { validationErrors } = this.state;
                      delete validationErrors.customerPhone;
                      this.setState({ validationErrors });
                      VS.onInput("phone", e);
                    }}
                  />
                </InputErrorMsgWrapper>
              </FormBody>
            </FormBox>

            <FormBox>
              <FormHead width={InputTitleWidth(i18n)}>고객 이메일</FormHead>
              <FormBody>
                <InputErrorMsgWrapper isError={validationErrors.customerEmail} message={validationErrors.customerEmail}>
                  <input
                    type="text"
                    name="customerEmail"
                    className="comm-inp"
                    placeholder="고객 이메일을 입력하세요"
                    defaultValue={projectCustomerEmail}
                    key={projectCustomerEmail}
                    onChange={() => {
                      const { validationErrors } = this.state;
                      delete validationErrors.customerEmail;
                      this.setState({ validationErrors });
                    }}
                  />
                </InputErrorMsgWrapper>
              </FormBody>
            </FormBox>

            <FormBox>
              <FormHead width={InputTitleWidth(i18n)}>현장 관리자</FormHead>
              <FormBody>
                <select
                  name="siteManagerId"
                  className="comm-inp comm-select"
                  value={projectSiteManagerId}
                  onChange={(e) => this.setState({ projectSiteManagerId: e.target.value })}
                >
                  <option value="">선택 안 함</option>
                  {siteManagers.map((m) => (
                    <option key={m.id} value={m.id}>{m.userName}</option>
                  ))}
                </select>
              </FormBody>
            </FormBox>

            <FormBox>
              <FormHead width={InputTitleWidth(i18n)}>프로젝트 상태</FormHead>
              <FormBody>
                <StatusRadioGroup>
                  {[
                    { value: "1", label: "설치전",   color: "#888e98" },
                    { value: "2", label: "설치중",   color: "#f59e0b" },
                    { value: "3", label: "설치완료", color: "#1ab245" },
                    { value: "4", label: "보완요청", color: "#ff5353" },
                  ].map(({ value, label, color }) => (
                    <StatusRadioLabel
                      key={value}
                      color={color}
                      active={projectStatus === value}
                    >
                      <input
                        type="radio"
                        name="status"
                        value={value}
                        checked={projectStatus === value}
                        onChange={(e) => this.setState({ projectStatus: e.target.value })}
                      />
                      {label}
                    </StatusRadioLabel>
                  ))}
                </StatusRadioGroup>
              </FormBody>
            </FormBox>

            {projectStatus === "4" && (
              <FormBox>
                <FormHead width={InputTitleWidth(i18n)}>보완요청 메시지</FormHead>
                <FormBody>
                  <textarea
                    className="comm-inp"
                    rows={4}
                    placeholder="보완 요청 내용을 입력하세요"
                    value={projectRequestMsg}
                    onChange={(e) => this.setState({ projectRequestMsg: e.target.value })}
                    style={{ resize: "vertical", padding: "8px", fontSize: "14px", lineHeight: "1.6", fontFamily: "inherit" }}
                  />
                </FormBody>
              </FormBox>
            )}

            {projectStatus === "4" && (
              <FormBox>
                <FormHead width={InputTitleWidth(i18n)} style={{ verticalAlign: "top", paddingTop: "10px" }}>보완요청 이미지</FormHead>
                <FormBody style={{ verticalAlign: "top" }}>
                <RequestFileList>
                  {[0, 1, 2, 3, 4].map((i) => {
                    const fileInfo = requestFiles[i];
                    return (
                      <RequestFileItem key={i}>
                        <RequestFileThumb>
                          {fileInfo ? (
                            <RequestFilePreview fileInfo={fileInfo} />
                          ) : (
                            <RequestFileEmpty>
                              <span>+</span>
                              <p>파일 {i + 1}</p>
                            </RequestFileEmpty>
                          )}
                        </RequestFileThumb>
                        <RequestFileActions>
                          <label htmlFor={`requestFile${i}`} className="upload-btn">
                            {fileInfo ? "변경" : "추가"}
                          </label>
                          <input
                            id={`requestFile${i}`}
                            type="file"
                            style={{ display: "none" }}
                            onChange={(e) => this.handleRequestFileChange(i, e)}
                          />
                          {fileInfo && (
                            <button
                              type="button"
                              className="remove-btn"
                              onClick={() => this.handleRequestFileRemove(i)}
                            >
                              삭제
                            </button>
                          )}
                        </RequestFileActions>
                      </RequestFileItem>
                    );
                  })}
                </RequestFileList>
                </FormBody>
              </FormBox>
            )}
          </FormContainer>

          <div style={{ display: "flex", justifyContent: "space-between", marginTop: "20px", maxWidth: "1176px", marginLeft: "20px" }}>
            <DeleteButton type="button" onClick={this.handleDeleteProject}>
              {t('key294')}
            </DeleteButton>
            <BtnGroup>
              <button type="button" className="cancel-btn" onClick={() => this.props.history.push(ROUTES.PROJECT.MAIN)}>
                취소
              </button>
              <button type="button" onClick={this.handleFacilityUpdate}>
                {t('key60')}
              </button>
              <button type="submit">{t('key61')}</button>
            </BtnGroup>
          </div>
        </FormWapper>

        {/* 프로젝트 연동 회원 섹션 */}
        <MemberSection>
          <MemberSectionHeader>
            <h3>프로젝트 연동 회원</h3>
            <button type="button" onClick={this.openMemberPopup}>
              회원 연동
            </button>
          </MemberSectionHeader>
          <table className="h-table">
            <colgroup>
              <col style={{ width: "10%" }} />
              <col style={{ width: "20%" }} />
              <col style={{ width: "20%" }} />
              <col style={{ width: "35%" }} />
              <col style={{ width: "15%" }} />
            </colgroup>
            <thead>
              <tr>
                <th>회원번호</th>
                <th>이름</th>
                <th>전화번호</th>
                <th>이메일</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {linkedMembers.length > 0 ? (
                linkedMembers.map((m) => (
                  <tr key={m.id}>
                    <td>{m.userId}</td>
                    <td>{m.userName}</td>
                    <td>{m.phone}</td>
                    <td>{m.email}</td>
                    <td>
                      <MemberRemoveBtn
                        type="button"
                        onClick={() => this.handleRemoveMember(m.userId)}
                      >
                        삭제
                      </MemberRemoveBtn>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="5">연동된 회원이 없습니다.</td>
                </tr>
              )}
            </tbody>
          </table>
        </MemberSection>

        {/* 회원 선택 팝업 */}
        {showMemberPopup && (
          <PopupOverlay onClick={this.closeMemberPopup}>
            <PopupBox onClick={(e) => e.stopPropagation()}>
              <PopupHeader>
                <h3>회원 목록</h3>
                <button type="button" onClick={this.closeMemberPopup}>✕</button>
              </PopupHeader>
              <PopupSearch>
                <input
                  type="text"
                  placeholder="이름 또는 전화번호로 검색"
                  value={popupKeyword}
                  onChange={(e) => this.setState({ popupKeyword: e.target.value, popupPage: 1 })}
                />
              </PopupSearch>
              <PopupBody>
                <table className="h-table">
                  <colgroup>
                    <col style={{ width: "8%" }} />
                    <col style={{ width: "18%" }} />
                    <col style={{ width: "18%" }} />
                    <col style={{ width: "20%" }} />
                    <col style={{ width: "36%" }} />
                  </colgroup>
                  <thead>
                    <tr>
                      <th></th>
                      <th>아이디</th>
                      <th>이름</th>
                      <th>전화번호</th>
                      <th>이메일</th>
                    </tr>
                  </thead>
                  <tbody>
                    {pagedMembers.length > 0 ? (
                      pagedMembers.map((m) => {
                        const isLinked = linkedUserIds.includes(m.id);
                        const isSelected = selectedMemberIds.includes(m.id);
                        return (
                          <tr key={m.id} className={isLinked ? "linked" : ""}>
                            <td>
                              <input
                                type="checkbox"
                                checked={isLinked || isSelected}
                                disabled={isLinked}
                                onChange={() => this.toggleMemberSelection(m.id)}
                              />
                            </td>
                            <td>{m.userId}</td>
                            <td>{m.userName}</td>
                            <td>{m.phone}</td>
                            <td>{m.email}</td>
                          </tr>
                        );
                      })
                    ) : (
                      <tr>
                        <td colSpan="5">
                          {popupKeyword ? "검색 결과가 없습니다." : "등록된 회원이 없습니다."}
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
                {popupTotalPageCount > 1 && (
                  <PaginationButtons
                    totalPageCount={popupTotalPageCount}
                    currentPage={popupPage}
                    onChangePage={(page) => this.setState({ popupPage: page })}
                  />
                )}
              </PopupBody>
              <PopupFooter>
                <button type="button" onClick={this.closeMemberPopup}>취소</button>
                <button
                  type="button"
                  onClick={this.handleAddMembers}
                  disabled={selectedMemberIds.length === 0}
                >
                  추가
                </button>
              </PopupFooter>
            </PopupBox>
          </PopupOverlay>
        )}
      </>
    );
  }
}

const FormWapper = styled.form`
  width: 1176px;
  margin: 55px auto 120px;
`;
const FormContainer = styled.div`
  max-width: 1176px;
  width: 100%;
  margin: 55px auto 20px;
  border: 1px solid #4b515b;
  border-width: 1px 0 1px;
`;
const FormBox = styled.div`
  padding: 24px 0;
  border-bottom: 1px solid #e3e5e7;
`;
const FormHead = styled.p`
  ${({ width }) => width ? `width: ${width};` : 'width: 140px;'}
  display: inline-block;
  font-size: 16px;
  color: #191919;
  font-weight: 600;
  padding-left: 12px;
  ${({ required }) => required && (
    `&::after {
      content: " *";
      color: #FF5353;
    }`
  )}
`;
const FormBody = styled.div`
  display: inline-block;
  input, select {
    border-radius: 4px;
  }
  .comm-inp {
    width: 436px;
  }
  .comm-select {
    height: 38px;
    border: 1px solid #d5d8de;
    padding: 0 10px;
    font-size: 14px;
  }
`;
const BtnGroup = styled.div`
  max-width: 1176px;
  width: 100%;
  text-align: right;
  margin: 0 auto;
  button {
    width: 120px;
    font-size: 14px;
    padding: 10px 0;
    text-align: center;
    border-radius: 5px;
    font-weight: 600;
    margin-left: 10px;
    &.cancel-btn {
      color: var(--secondary-500);
      background-color: transparent;
      border: 1px solid var(--secondary-500);
    }
    &:nth-child(2) {
      color: var(--grey-900);
      background-color: transparent;
      border: 1px solid var(--primary-500);
    }
    &:last-child {
      color: var(--grey-900);
      background-color: var(--primary-500);
      border: 1px solid var(--primary-500);
    }
  }
`;

const StatusRadioGroup = styled.div`
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
`;

const StatusRadioLabel = styled.label`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 7px 16px;
  border-radius: 20px;
  border: 2px solid ${({ active, color }) => active ? color : "#d5d8de"};
  background-color: ${({ active, color }) => active ? `${color}18` : "#fff"};
  color: ${({ active, color }) => active ? color : "#888e98"};
  font-size: 14px;
  font-weight: ${({ active }) => active ? "700" : "500"};
  cursor: pointer;
  transition: all 0.15s;

  input[type="radio"] {
    display: none;
  }

  &:hover {
    border-color: ${({ color }) => color};
    color: ${({ color }) => color};
  }
`;

const MemberSection = styled.div`
  max-width: 1176px;
  margin: 40px auto 60px;
  .h-table {
    width: 100%;
    border-collapse: collapse;
    th, td {
      padding: 12px 10px;
      font-size: 14px;
      text-align: center;
      border-bottom: 1px solid #e3e5e7;
    }
    th {
      background-color: #f5f6f8;
      font-weight: 600;
      color: #4b515b;
    }
    tr.linked td {
      color: #aaa;
    }
  }
`;
const MemberSectionHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 0 12px;
  border-top: 2px solid #4b515b;
  margin-bottom: 0;
  h3 {
    font-size: 16px;
    font-weight: 700;
    color: #191919;
  }
  button {
    font-size: 13px;
    padding: 7px 18px;
    border-radius: 5px;
    font-weight: 600;
    color: var(--grey-900);
    background-color: var(--primary-500);
    border: 1px solid var(--primary-500);
    cursor: pointer;
    &:hover {
      background-color: var(--primary-600);
    }
  }
`;
const MemberRemoveBtn = styled.button`
  font-size: 12px;
  width: 45px;
  padding: 3px 0;
  text-align: center;
  border-radius: 5px;
  cursor: pointer;
  background-color: #ff5353;
  border: 1px solid #ff5353;
  color: #fff;
  &:hover {
    background-color: #d93636;
  }
`;
const PopupOverlay = styled.div`
  position: fixed;
  inset: 0;
  background-color: rgba(0, 0, 0, 0.45);
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
`;
const PopupBox = styled.div`
  background: #fff;
  border-radius: 8px;
  width: 720px;
  max-height: 80vh;
  display: flex;
  flex-direction: column;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.18);
`;
const PopupHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 18px 24px;
  border-bottom: 1px solid #e3e5e7;
  h3 {
    font-size: 16px;
    font-weight: 700;
    color: #191919;
  }
  button {
    background: none;
    border: none;
    font-size: 18px;
    cursor: pointer;
    color: #888;
    &:hover { color: #333; }
  }
`;
const PopupSearch = styled.div`
  padding: 12px 24px;
  border-bottom: 1px solid #e3e5e7;
  input {
    width: 100%;
    height: 36px;
    padding: 0 12px;
    font-size: 14px;
    border: 1px solid #d5d8de;
    border-radius: 4px;
    box-sizing: border-box;
    &:focus {
      outline: none;
      border-color: var(--secondary-500);
    }
  }
`;
const PopupBody = styled.div`
  overflow-y: auto;
  padding: 16px 24px;
  flex: 1;
  .h-table {
    width: 100%;
    border-collapse: collapse;
    th, td {
      padding: 10px 8px;
      font-size: 13px;
      text-align: center;
      border-bottom: 1px solid #e3e5e7;
    }
    th {
      background-color: #f5f6f8;
      font-weight: 600;
      color: #4b515b;
    }
    tr.linked td {
      color: #bbb;
    }
    input[type="checkbox"] {
      cursor: pointer;
      &:disabled { cursor: default; }
    }
  }
`;
const PopupFooter = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  padding: 16px 24px;
  border-top: 1px solid #e3e5e7;
  button {
    font-size: 14px;
    padding: 8px 24px;
    border-radius: 5px;
    font-weight: 600;
    cursor: pointer;
    &:first-child {
      background: transparent;
      border: 1px solid var(--secondary-500);
      color: var(--secondary-500);
    }
    &:last-child {
      background: var(--primary-500);
      border: 1px solid var(--primary-500);
      color: var(--grey-900);
      &:disabled {
        background: #aaa;
        border-color: #aaa;
        cursor: default;
      }
    }
  }
`;

const RequestFileList = styled.div`
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
  padding-top: 4px;
`;

const RequestFileItem = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
`;

const RequestFileThumb = styled.div`
  width: 120px;
  height: 100px;
  border: 2px dashed #d5d8de;
  border-radius: 8px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f9fafb;
`;

const RequestFileEmpty = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #c0c4cc;
  span {
    font-size: 28px;
    line-height: 1;
    font-weight: 300;
  }
  p {
    font-size: 12px;
    margin-top: 6px;
  }
`;

const RequestFileActions = styled.div`
  display: flex;
  gap: 6px;
  .upload-btn {
    font-size: 12px;
    padding: 4px 12px;
    border-radius: 4px;
    background: var(--primary-500);
    color: var(--grey-900);
    cursor: pointer;
    &:hover {
      background: var(--primary-600);
    }
  }
  .remove-btn {
    font-size: 12px;
    padding: 4px 10px;
    border-radius: 4px;
    background: #ff5353;
    color: #fff;
    border: none;
    cursor: pointer;
    &:hover {
      background: #d93636;
    }
  }
`;

function RequestFilePreview({ fileInfo }) {
  const [imgSrc, setImgSrc] = useState(null);

  useEffect(() => {
    if (!fileInfo?.isImage) return;
    let objectUrl;
    axios.get(`/api/file/${fileInfo.id}`, { responseType: "blob" })
      .then((res) => {
        objectUrl = URL.createObjectURL(res.data);
        setImgSrc(objectUrl);
      })
      .catch(() => {});
    return () => { if (objectUrl) URL.revokeObjectURL(objectUrl); };
  }, [fileInfo?.id]);

  if (fileInfo.isImage) {
    if (!imgSrc) return <div style={{ fontSize: "11px", color: "#aaa" }}>로딩중...</div>;
    return (
      <img
        src={imgSrc}
        alt="첨부이미지"
        style={{ width: "100%", height: "100%", objectFit: "cover" }}
      />
    );
  }
  return (
    <FileNameLabel>
      <span className="icon">📄</span>
      <span className="name">{fileInfo.name || "파일"}</span>
    </FileNameLabel>
  );
}

const FileNameLabel = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
  padding: 8px;
  .icon { font-size: 24px; }
  .name {
    font-size: 10px;
    color: #555;
    word-break: break-all;
    text-align: center;
    max-width: 100px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`;

export default withTranslation()(ProjectEdit);
